// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"93833a4c","453":"361f310c","521":"a547ee3d"}[chunkId] + ".chunk.js";
};